import script from "./ConsentCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsentCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./ConsentCheckbox.vue?vue&type=style&index=0&id=6a334af0&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a334af0"]])

export default __exports__